import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import cn from 'classnames'
import {subjectsSelector, subjectsLoadStateSelector, subjectsCursorSelector, loadSubjects, handleSubjectClick} from '../../modules/subjects'
import {showModal, QBM_CRUD} from '../../modules/modals'
import ButtonPanel from './ButtonPanel'
import Loader from '../common/Loader'
import {sortCB} from "../../helpers/common"
import { handleSetTutorialStep, tutorialModeSelector, CLICK_CREATE_SUBJECT_STEP, SELECT_SUBJECT_STEP, tutorialCurrentStepSelector, handleStep_createSubjectModalStep, handleStep_clickCreateCategoryStep, handleStep_createCategoryModalStep, CLICK_CREATE_CATEGORY_STEP } from '../../modules/tutorial'
import {QBM_NAV_SUBJECTS} from '../../modules/app'
import { isTeacherOrganisationSelector } from '../../modules/profile'
import {toastr} from 'react-redux-toastr'


class Subjects extends Component {
    render() {
        const {openItemId, toggleSubjects} = this.props
        const isOpen = openItemId === QBM_NAV_SUBJECTS
        const {formatMessage} = this.context
        return (
            <div className="qbm-accordion-component">
                <div
                    className="qbm-accordion-title"
                    onClick={toggleSubjects}
                >{formatMessage("Subjects")}
                    <div className={cn({"qbm-accordion-arrow":1, open : isOpen})}></div>
                </div>
                <div className={cn("posr", {"qbm-accordion-body":1, open : isOpen})} ref={this.getAccordionBodyRef}>
                    {
                        this.getBody()
                    }
                </div>
            </div>
        )
    }

    getBody = () => {
        const {subjects, subjectsLoadState : {loading}, subjectsCursor} = this.props
        if (loading) return <Loader className="accordion-sidebar-preloader" />
        return (
            <React.Fragment>
                <div className="qbm-accordion-content">
                    {
                        subjects
                            .sort(sortCB)
                            .map(({id, name}, index) => {
                                let _props = {}
                                if (index === 0) {
                                    _props = {
                                        ..._props,
                                        ref : this.getFirstSubjectRef
                                    }
                                }
                                return (
                                    <div
                                        key = {id}
                                        className={cn({
                                            "qbm-accordion-content__item" : 1,
                                            "qbm-accordion-content__item--selected" : (subjectsCursor === id)
                                        })}
                                        onClick={this._handleSubjectClick(id)}
                                        {..._props}
                                    >
                                        <span className="text-ellipsis">{name}</span>
                                    </div>
                                )
                            })
                    }
                </div>
                <ButtonPanel
                    handleAddCreateClick = {this.handleActionButtonClick("create")}
                    handleDeleteClick = {this.handleActionButtonClick("delete")}
                    handleUpdateClick = {this.handleActionButtonClick("update")}
                    isUpdateActive = {!!subjectsCursor}
                    isDeleteActive = {!!subjectsCursor}
                    tooltips = {{
                        plus : true,
                        step : CLICK_CREATE_SUBJECT_STEP,
                    }}
                />
            </React.Fragment>
        )
    }

    getFirstSubjectRef = ref => this.firstSubjectRef = ref
    getAccordionBodyRef = ref => this.accordionBodyRef = ref

    componentDidMount() {
        const {subjectsLoadState : {loaded, loading}, loadSubjects} = this.props
        if (!loaded && !loading) {
            loadSubjects()
        }

        this.handleTutorial()
    }

    componentDidUpdate() {
        this.handleTutorial()
    }

    handleTutorial = () => {
        const {handleSetTutorialStep, tutorialModeIsOn} = this.props
        if (tutorialModeIsOn) {
            handleSetTutorialStep({
                step : SELECT_SUBJECT_STEP,
                container : this.accordionBodyRef,
                target : this.firstSubjectRef,
            })
        }
    }

    componentWillUnmount() {
        const {handleSetTutorialStep} = this.props
        handleSetTutorialStep({
            step : SELECT_SUBJECT_STEP,
            container : null,
            target : null,
        })
    }

    _handleSubjectClick = (id) => () => {
        const {handleSubjectClick, tutorialModeIsOn, tutorialCurrentStep, handleStep_clickCreateCategoryStep} = this.props
        handleSubjectClick(id)

        if (tutorialModeIsOn && tutorialCurrentStep === SELECT_SUBJECT_STEP) {
            handleStep_clickCreateCategoryStep()
        }
    }
    handleActionButtonClick = (action) => () => {
        const {showModal, subjectsCursor, tutorialModeIsOn, tutorialCurrentStep, handleStep_createSubjectModalStep, handleStep_createCategoryModalStep} = this.props
        const {isTeacherOrganisation, permission} = this.props;
        const {formatMessage} = this.context;
        if('delete' == action){
            if(isTeacherOrganisation && permission && !permission.allow_delete_question){
                toastr.warning(formatMessage('notPermissionTitle'), formatMessage('notPermissionMessage'));
                return ;
            }
        }
        
        if (!subjectsCursor && ["delete", "update"].includes(action)) return
        showModal({modalType : QBM_CRUD, modalProps : {qbmEntity : "subject", qbmCrudAction : action}})

        if (tutorialModeIsOn && tutorialCurrentStep === CLICK_CREATE_SUBJECT_STEP) {
            handleStep_createSubjectModalStep()
        }

        if (tutorialModeIsOn && tutorialCurrentStep === CLICK_CREATE_CATEGORY_STEP) {
            handleStep_createCategoryModalStep()
        }
    }
    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => ({
        subjects : subjectsSelector(state),
        subjectsLoadState : subjectsLoadStateSelector(state),
        subjectsCursor : subjectsCursorSelector(state),
        tutorialModeIsOn : tutorialModeSelector(state),
        tutorialCurrentStep : tutorialCurrentStepSelector(state),
        permission: state.profile.permission || {},
        isTeacherOrganisation: isTeacherOrganisationSelector(state),
    }),
    { handleSubjectClick, loadSubjects, showModal, handleSetTutorialStep, handleStep_createSubjectModalStep, handleStep_clickCreateCategoryStep, handleStep_createCategoryModalStep }
)(Subjects)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/Subjects.js